import React from 'react'
import { Link } from 'react-router-dom'

const Tittle = () => {
  return (
<section
  className="page-title"
  style={{ backgroundImage: "url(/assets/images/background/11.jpg)" }}
>
  <div className="anim-icons full-width">
    <span className="icon icon-bull-eye" />
    <span className="icon icon-dotted-circle" />
  </div>
  <div className="auto-container">
    <div className="title-outer">
      <h1>Attend</h1>
      <ul className="page-breadcrumb">
        <li>
          <Link to="index-2.html">Home</Link>
        </li>
        <li>Attend</li>
      </ul>
    </div>
  </div>
</section>

  )
}

export default Tittle